export const toLowerCaseKeys = <T extends string, K>(obj: Record<T, K>) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // @ts-expect-error wrong typing
    acc[key.toLowerCase()] = value;
    return acc;
  }, {} as typeof obj);
};
